import clsx from "clsx";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import { IClassSummary } from "../../../../../state.d";
import {
  classDataPath,
  activeLearningClassDataPath,
} from "../../../../../teacherStore";

import styles from "./ClassItem.module.scss";

export type Props = {
  klassName: IClassSummary;
  forward?: boolean;
  forwardData?: boolean;
  isActive?: boolean;
  onChooseClass?: (id: number, assumed_entrance_year?: number) => void;
};

const ClassItem: React.FC<Props> = ({
  klassName,
  forward = false,
  forwardData = false,
  isActive = false,
  onChooseClass,
}) => {
  const history = useHistory();
  const location = useLocation();
  const isActiveLearningParams = new URLSearchParams(location.search).get(
    "isActiveLearning",
  );

  return (
    <button
      className={clsx(styles.class, isActive && styles.active)}
      disabled={!klassName.charged}
      onClick={() => {
        if (onChooseClass) {
          klassName.assumed_entrance_year
            ? onChooseClass(klassName.id, klassName.assumed_entrance_year)
            : onChooseClass(klassName.id);
        }
        if (forward && forwardData) {
          const path = isActiveLearningParams
            ? `${activeLearningClassDataPath}/${klassName.id}`
            : `${classDataPath}/${klassName.id}`;
          const state = { nameClass: klassName.full_name };
          history.push(path, state);
        }
      }}
    >
      {klassName.charged && <span className={styles.badge}>担当</span>}
      <p className={styles.name}>{klassName.name}</p>
    </button>
  );
};

export default ClassItem;
